import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

// antd
import { Row, Typography, message, theme } from 'antd'

// components
import Button from '../../components/button/button'

// slices
import { workSpaceUnAssign } from '../workSpace/workSpace.slice'
import { talentState } from './talent.slice'

// assets
import { UnAssignIcon } from '../../assets/icons'

const WorkSpaceUnAssignModal = ({ cancelModal, refreshTalent }) => {
    const { useToken } = theme
    const { token } = useToken()

    const dispatch = useDispatch()

    const { Title, Text } = Typography

    const { selectedData } = useSelector(talentState)

    const [buttonLoading, setButtonLoading] = useState(false)

    // UNASSIGN WORKSPACE
    const unAssignWorkSpace = async () => {
        setButtonLoading(true)
        const result = await dispatch(
            workSpaceUnAssign({
                userId: selectedData?._id,
            })
        )
        const data = result?.payload?.data

        setButtonLoading(false)

        if (data) {
            const { success, message: checkMessage } = data
            if (success) {
                message.success(
                    checkMessage || 'Workspace unassigned successfully'
                )
                refreshTalent()
                cancelModal()
            } else {
                message.error(
                    checkMessage || 'Something went wrong, try again later.'
                )
                cancelModal()
            }
        } else {
            message.error('Something went wrong, try again later.')
            cancelModal()
        }
    }

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                // alignItems: 'center',
                // justifyContent: 'center',
            }}
        >
            <Row
                style={{
                    marginTop: '18px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <div
                    style={{
                        height: '30px',
                        width: '30px',
                    }}
                >
                    <UnAssignIcon />
                </div>
                <Title level={3}>Unassign Workspace</Title>
            </Row>

            <Row
                style={{
                    marginTop: '18px',
                }}
            >
                <Text className="sub-title" style={{ textAlign: 'center' }}>
                    Are you sure you want to unassign the resource from the
                    SoftwareCo workspace?
                </Text>
            </Row>

            <Row
                align={'middle'}
                justify={'end'}
                style={{
                    marginTop: '34px',
                }}
            >
                <Button
                    props={{
                        text: 'Cancel',
                        buttonType: 'link',
                        onClick: () => cancelModal(),
                        style: {
                            color: token.colorPalette.baseColor.black,
                        },
                    }}
                />
                <Button
                    props={{
                        text: 'Unassign',
                        onClick: () => unAssignWorkSpace(),
                        loadingButton: buttonLoading,
                    }}
                />
            </Row>
        </div>
    )
}

export default WorkSpaceUnAssignModal
